'use strict';
var app = app || angular.module('harriApp');

app.controller('ClaimProfileController', ["$scope", "$stateParams", "$rootScope", "$q", "$state", "OMISChecker", "ClaimProfileAPI", "hFormReference", function ($scope,$stateParams,$rootScope,$q,$state,OMISChecker,ClaimProfileAPI,hFormReference) {

  /**
   * =====================
   *         Vars
   * =====================
   */
  var modal = {
    'confirmDecline' : '#decline-confirmation-modal',
    'claimForm' : '#claim-form-modal'
  };

  $scope.brandId = $stateParams.brandId;


  /**
   * =====================
   *        Methods
   * =====================
   */

  /**
   * Claim profile click open the
   * modal
   */
  $scope.claimMarketingProfile = function(){
    hFormReference
      .getForm('claim_brand/basic_info')
      .then(function(form){

        var loadedData = {};

        loadedData['brand_id'] = $scope.brandId;

        if( $scope.brandData.email ){
          loadedData['email'] = $scope.brandData.email;
        }

        if( $scope.brandData.phone ){
          loadedData['phone'] = $scope.brandData.phone;
        }

        if( $scope.brandData.contact_name ){
          var parsedName = parseContactName( $scope.brandData.contact_name );
          loadedData['first_name'] = parsedName.firstName;

          if( parsedName.lastName ){
            loadedData['last_name'] = parsedName.lastName;
          }
        }


        form.scope.load({
          'claim_registration' : loadedData
        });


        $(modal.claimForm).modal('show');

      });
  }


  var parseContactName = function( contactFullName ){
    var name = {};

    var nameArray = contactFullName.split(' ');
    name.firstName = nameArray[0];

    if( nameArray.length > 1 ){
      name.lastName = nameArray.slice( 1 , nameArray.length ).join(' ');
    }

    return name;
  }


  /**
   * decline profile click open the
   * confirmation modal
   */
  $scope.declineMarketingProfile = function(){
    $(modal.confirmDecline).modal({
      'show' : true,
      'backdrop' : 'static'
    });
  }


  $scope.confirmDeclineMarketingProfile = function(){
    /**
     * @todo:
     * implement after decline redirect
     */
    ClaimProfileAPI
      .declineBrandProfile( $scope.brandId )
      .then(function( resp ){
        $(modal.confirmDecline).modal('hide');
        hRedirect('/');
      });
  }


  $scope.formatClaimRequest = function( userData , profileData ){

    var defer = $q.defer();

    var requestData = _.pick( profileData ,'hecs','Cuisine','BrandMedia');

    /**
     * Add Brand Data
     */
    var brand = _.pick( profileData ,'email','name','description','phone');
    requestData.Brand = {
      'email'       : brand.email,
      'brand_name'  : brand.name,
      'description' : brand.description,
      'phone'       : brand.phone
    }

    /**
     * Add user data
     */
    requestData.User = _.pick(userData ,'first_name' , 'last_name' , 'password', 'email');


    if( profileData.Location && profileData.Location.length ){

      requestData.Location = profileData.Location;
      defer.resolve( requestData );

    }else{
      var googleMaps = getAngularService('googleMaps');
      googleMaps
        .getDetails({placeId: userData.google_place.place_id}, function (r) {
          requestData.google_place = r;
          defer.resolve( requestData );
      });
    }

    return defer.promise;
  }



  /**
   * Controller entry point
   */
  var init = function(){

    $timeout(function(){
      OMISChecker.setIsOMISFlag( true , $scope.brandId );
    },2);

    ClaimProfileAPI
      .getBrandData( $scope.brandId )
      .then(function(resp){
        $scope.brandData = resp.data.data;
      });
  }


  init();

}]);


app.factory('OMISChecker',["$rootScope", "$templateRequest", "$sce", "$interpolate", "$state", function( $rootScope,$templateRequest,$sce, $interpolate , $state ){

  var checker =  {};

  checker.isOMISUser = false;
  checker.brandId = '';

  checker.setIsOMISFlag = function( isOMIS, brandId ){
    checker.isOMISUser = isOMIS;
    checker.brandId = brandId;
    checker.broadCastIsOMISChanged();
  }

  checker.broadCastIsOMISChanged = function(){
    $rootScope.$broadcast( 'isOMISChanged' , { 'isOMISUser' : checker.isOMISUser , 'brandId' : checker.brandId });
  }

  checker.getTickerHTML = function(){
    var templateUrl = $sce.getTrustedResourceUrl('../scripts/global-directives/html/omis-ticker.html');
    return $templateRequest(templateUrl);
  }

  checker.renderOMISHeaderIfNeeded = function( scope ){
    if( checker.isOMISUser && $state.current.name != 'brand-marketing' ){
      checker.getTickerHTML().then(function(tmplt){
        $('header.top-header').after( $interpolate(tmplt)( { OMISClaimBrandId:checker.brandId , isOMISUser : checker.isOMISUser } ) );
      });
    }
  }

  checker.removeOMISHeader = function(){
    checker.isOMISUser = false;
    checker.brandId = '';
    $('.claimed-profile-ticker').remove();
  }
  return checker;
}]);


/**
 * Claim profile API interface
 */
app.factory('ClaimProfileAPI',["$q", "httpHelper", "asyncGlobalHandler", function( $q , httpHelper, asyncGlobalHandler ){
  var API = {};

  API.declineBrandProfile = function( brandId ){
    var promise = httpHelper.p( publicConfiguration["OMISServerBaseURL"] + "/brand/" + brandId + '/decline' );
    asyncGlobalHandler.watchPromise( promise );
    return promise;
  }


  API.claimBrandProfile = function( requestData ){
    var promise = httpHelper.put('claim_profile',requestData);
    asyncGlobalHandler.watchPromise( promise );
    return promise;
  }


  API.getBrandData = function( brandId ){
    var promise = httpHelper.g( publicConfiguration["OMISServerBaseURL"] + "/brand/" + brandId );
    asyncGlobalHandler.watchPromise( promise );
    return promise;
  }

  API.notifyOMISAboutClaimedProfile = function( brandId ){
    var promise = httpHelper.p( publicConfiguration["OMISServerBaseURL"] + "/brand/" + brandId + '/claim' );
    asyncGlobalHandler.watchPromise( promise );
    return promise;
  }

  API.notifyOMISAboutLoggedInUser = function( brandId ){
    var promise = httpHelper.p( publicConfiguration["OMISServerBaseURL"] + "/brand/" + brandId + '/loggedin' );
    asyncGlobalHandler.watchPromise( promise );
    return promise;
  }

  API.notifyOMISAboutViewBrand = function( brandId ){
    var promise = httpHelper.p( publicConfiguration["OMISServerBaseURL"] + "/brand/" + brandId + '/view' );
    asyncGlobalHandler.watchPromise( promise );
    return promise;
  }

  return API;
}]);


/**
 * ==========================
 *       Form Handler
 * ==========================
 */


/**
 * Virtual Registration for claim
 * brand profile
 */
app.directive('claimBrandProfileForm', ["$timeout", "$q", "$state", "httpHelper", "hFormReference", "ClaimProfileAPI", "OMISChecker", "hUser", function ($timeout, $q, $state, httpHelper, hFormReference, ClaimProfileAPI, OMISChecker,hUser) {
  return {
    link : function( scope , element , attrs ){

      // Save form view name
      var formView;

      scope.firstNameMaxLength = 32;
      scope.lastNameMaxLength = 32;

      /**
       * Before Save CallBack object function
       */
      var beforeSaveCallBack = {};
      /**
       * Before Save CallBack
       * @param formScope
       * @param formView
       */
      var beforeSaveCallBackInit = function(formScope,formView ){
        beforeSaveCallBack[formView] = function( data , isValid ){

          var defer = $q.defer();
          if( isValid ){

            scope.formatClaimRequest( data , angular.copy(scope.brandData))
              .then(function(formattedRequestData){

                ClaimProfileAPI
                  .claimBrandProfile(formattedRequestData)
                  .then(function( resp ){

                    if( resp.data.status_code == 200 ){
                      /**
                       * Notify OMIS that brand
                       * claimed successfully
                       */
                      ClaimProfileAPI.notifyOMISAboutClaimedProfile( scope.brandId );

                      OMISChecker.removeOMISHeader();

                      hUser.logout().then(function () {
                        hUser.init().then(function () {
                          $state.go('appLayout.harriSH.dashboard');
                        });
                      });

                      //hRedirect('/user/refresh');

                    }else{
                      formScope.invalidate( resp.data );
                      defer.resolve( false );
                    }


                    defer.resolve( false );

                  },function( resp ){
                    defer.resolve( false );
                  });

              });

          }else{
            defer.resolve(formScope.forms.claim_registration);
          }

          return defer.promise;
        };
        formScope.addBeforeSaveCallback( beforeSaveCallBack );
      }


      /**
       * Initiate form and the callbacks that applied on it
       * @param formView
       */
      var initForm = function( formView ){

        hFormReference
          .getForm(formView)
          .then(function (form) {
            var formScope = form.scope;

            /* init beforeSaveCallbach */
            beforeSaveCallBackInit( formScope , formView );

          });
      }


      /**
       * Form Entry point
       */
      var init = function(){
        formView = attrs.view || "claim_brand/basic_info";
        initForm( formView )
      }

      init();
    }
  }
}]);

